import StyledSvgIconWrapper, { TStyledSvgIconWrapper } from "./wrappers/StyledSvgIconWrapper";

export const EuroIcon: React.FC<TStyledSvgIconWrapper> = ({ active = false, monochrome, ...props }) => {
  return (
    <StyledSvgIconWrapper {...props} active={active} width="65px" height="48px" viewBox="0 0 65 48">
      <g clipPath="url(#clip0_317_3)">
        <path
          d="M62.2 28.97V6.23998C62.2 3.88998 60.41 1.97998 58.19 1.97998H8.48001"
          strokeWidth="3.95"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#32B88E"
          className="stroke"
        />
        <path
          d="M50.41 45.7799H6.65C4.07 45.7799 1.97 43.6799 1.97 41.0899V13.3799C1.97 10.7899 4.06 8.68994 6.65 8.68994H50.41C52.99 8.68994 55.09 10.7899 55.09 13.3799V41.0899C55.09 43.6799 53 45.7799 50.41 45.7799Z"
          strokeWidth="3.95"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          stroke="#003939"
          className="stroke"
        />
        <path
          d="M28.53 34.74C32.6721 34.74 36.03 31.3821 36.03 27.24C36.03 23.0979 32.6721 19.74 28.53 19.74C24.3879 19.74 21.03 23.0979 21.03 27.24C21.03 31.3821 24.3879 34.74 28.53 34.74Z"
          strokeWidth="3.95"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          stroke="#32B88E"
          className="stroke"
        />
      </g>
      <defs>
        <clipPath id="clip0_317_3">
          <rect width="64.18" height="47.76" fill="white" />
        </clipPath>
      </defs>
    </StyledSvgIconWrapper>
  );
};
